import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, Checkbox } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import SubmitButton from "components/common/SubmitButton";

const AddEditReferrer = (props) => {
  const ADD_NEW = props.type === "addNew";
  const [submitAttempted, setSubmitAttempted] = React.useState(false);

  const validateForm = (values) => {
    const errors = {};
    if (!values.referrerName || values.referrerName.trim() === "") {
      errors.referrerName = "Referrer name is required";
    }
    return errors;
  };
  return (
    <Dialog
      title={ADD_NEW ? "Add Referrer" : `Edit ${props?.item?.referrerName}`}
      onClose={props.cancelEdit}
      width={600}
    >
      <Form
        onSubmit={props.onSubmit}
        initialValues={{
          active: true,
          forClients: true,
          forMatters: true,
          ...props.item,
        }}
        validator={validateForm}
        render={(formRenderProps) => (
          <>
            <div className="p-3 ps-4">
              <FormElement>
                <fieldset className="k-form-fieldset">
                  <div className="mb-2">
                    <Label className="label mt-1 mb-2 w-100">Name</Label>
                    <Field
                      name="referrerName"
                      component={Input}
                      placeholder="Enter Name"
                    />
                    {submitAttempted &&
                      formRenderProps.errors?.referrerName && (
                        <div className="fs-sm my-1 text-danger">
                          <i>{formRenderProps.errors.referrerName}</i>
                        </div>
                      )}
                  </div>
                  <div className="mb-2">
                    <Label className="label mt-1 mb-2 w-100">Details</Label>
                    <Field
                      name="referrerDetails"
                      component={Input}
                      placeholder="Enter Details"
                    />
                  </div>
                  <div className="d-flex align-items-center gap-3 mt-3">
                    <Field
                      name="active"
                      component={Checkbox}
                      label="Active"
                    />
                    <Field
                      name="forClients"
                      component={Checkbox}
                      label="For Clients"
                    />
                    <Field
                      name="forMatters"
                      component={Checkbox}
                      label="For Matters"
                    />
                  </div>
                </fieldset>
              </FormElement>
            </div>
            <div className="dialog-footer">
              <button
                className="bgBtnSecondary common-btn me-2"
                onClick={props.cancelEdit}
              >
                Cancel
              </button>
              <SubmitButton
                className="me-3"
                onClick={() => {
                  setSubmitAttempted(true);
                  formRenderProps.onSubmit();
                }}
                disabled={!formRenderProps.allowSubmit}
                isLoading={props.isSubmitting}
              >
                {ADD_NEW ? "Save" : "Update"}
              </SubmitButton>
            </div>
          </>
        )}
      />
    </Dialog>
  );
};

export default AddEditReferrer;
